import { useEffect } from 'react';

import { electronApis } from '@/features/electron-api';
import { logger } from '@/lib/logger';
import { AppCapability, isCapable } from '@/utils/capabilities';

export function useSettleContextConsent(
  userEmail: string | undefined,
  isOnboarded: boolean
) {
  useEffect(() => {
    if (!userEmail || !isOnboarded) return;
    if (!isCapable(AppCapability.ContextCapture)) return;

    electronApis.context.settleContextCollectionConsent().catch((error) => {
      logger.error('Context collection consent settle failed', { error });
    });
  }, [userEmail, isOnboarded]);
}
